import { useState, useContext, useEffect } from "react";
import { PostContext } from "../../providers/PostContext";
import { FeedContent } from "../../components/Feed";

export const Top = () => {
  const [page, setPage] = useState(1),
    [loading, setLoading] = useState(false);

  const { posts, getPostActivity } = useContext(PostContext);

  useEffect(() => {
    const handleLoadPosts = async () => {
      setLoading(true);

      await getPostActivity(page);

      setLoading(false);
    };

    handleLoadPosts();
  }, [page]);

  return <FeedContent setPage={setPage} posts={posts} loading={loading} />;
};
